import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import TopCard from "../../components/card/TopCard";
import CustomTable from "../../components/table/CustomTable";
import { GoPlus } from "react-icons/go";
import useOutsideClick from "../../hooks/useOutsideClick";
import Modal from "../../components/Modal";
import { WaybillModal } from "../../components/modal/WaybillModal";
import ViewDetail from "../../components/modal/ViewDetail";
import PaginationPane from "../../components/table/PaginationPane";
import useAggregator from "../../hooks/useAggregator";
import useRecycler from "../../hooks/useRecycler";
import useWaybill from "../../hooks/useWaybill";
import useResource from "../../hooks/useResource";
import { toMoney, toMoneyDecimal } from "../../utils/utils";
import SearchableDropdown from "../../components/input/SearchableDropdown";
import { MdDelete } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { GoDownload } from "react-icons/go";
import Character from "../../assets/images/Character.png";

//date range
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useCollector from "../../hooks/useCollector";
import { getAllRecyclerList } from "../../ds/recycler";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import DataCard from "../../components/card/DataCard";
import {
  gatOneSetting,
  getEnabledSettingUsers,
  parseSettingBoolean,
} from "../../ds/settings";
import DeleteFalseModal from "../../components/modal/DeleteFalseModal";
import DeleteModal from "../../components/modal/DeleteModal";

const headers = [
  "Offtaker",
  "Aggregators",
  "Gender",
  "Amount",
  "Quantity(Kg)",
  "Transaction Date",
  "Entry Date",
];

const detail = {
  "first Name": "Jehoshe",
  "last Name": "Baidera",
  "phone Number": "080331485238",
  "email Address": "Jehoshebaidera@gmail.com",
  address: "Wuse zone 3 Near Access bank Abuja, Nigeria",
  state: "Sagamu",
  lga: "amu",
  "year of incorporation": "14 January 2024",
  dateCreated: "14 January 2024",
};

const enabledUsersList = (res) => {
  if (Array.isArray(res)) return res;
  if (res?.code && res.code !== "00") return [];
  return Array.isArray(res?.data) ? res.data : [];
};

const userHasEnabledSetting = (res, settingName, accountId) => {
  if (accountId == null) return false;
  const item = enabledUsersList(res).find(
    (entry) => entry?.name === settingName,
  );
  if (!parseSettingBoolean(item?.value)) return false;
  return (item.users || []).some(
    (person) => String(person.id) === String(accountId),
  );
};

const Offtake = () => {
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState("");

  const [showModal, setShowModal] = useOutsideClick(wrapperRef);
  const [viewDetail, setViewDetail] = useOutsideClick(wrapperRef);
  const [editDetail, setEditDetail] = useOutsideClick(wrapperRef);
  const [showDeleteModal, setShowDeleteModal] = useOutsideClick(wrapperRef);
  const [showDeleteFalseModal, setShowDeleteFalseModal] =
    useOutsideClick(wrapperRef);
  const [showEditFalseModal, setShowEditFalseModal] =
    useOutsideClick(wrapperRef);

  const [aggregatorList, setAggregatorList] = useState([]);
  const [aggId, setAggId] = useState(null);
  const [aggGender, setAggGender] = useState(null);
  const [canDelete, setCanDelete] = useState(false);
  const [canShowTransDate, setCanShowTransDate] = useState(null);

  const [waybill, setWaybills] = useState([]);
  const [waybillDetail, setWaybillDetail] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const limit = 10;

  const [recyclerList, setRecyclerList] = useState([]);
  const [recycId, setRecycId] = useState(null);
  const [waybillId, setWaybillId] = useState({});
  const { program, user } = useSelector((state) => state.auth);
  const accountId = user?.id ?? user?.userId;

  const { gatAllAggregatorLists } = useAggregator();
  const { gatAllCollectorList } = useCollector();
  const { gatAllRecyclerLists } = useRecycler();
  const { loading, getAllWaybills, deleteOneWaybill, waybillDownload } = useWaybill();
  const { typeOfPlastic, sourceOfPlastic } = useResource(program);

  //for date range
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [formatStartDate, setFormatStartDate] = useState(null);
  const [formatEndDate, setFormatEndDate] = useState(null);
  const [canShowNewCollection, setCanShowNewCollection] = useState(null);
  const [canActivateEditTransaction, setCanActivateEditTransaction] =
    useState(false);


  const onChange = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    {
      start
        ? setFormatStartDate(moment(start).format("YYYY-MM-DD"))
        : setFormatStartDate(null);
    }

    {
      end
        ? setFormatEndDate(moment(end).format("YYYY-MM-DD"))
        : setFormatEndDate(null);
    }
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="flex flex-col gap-2">
      <div
        className="example-custom-input border border-gray-300 h-[44px] w-[240px] md:w-[170px] lg:w-[280px] p-2 rounded-md"
        onClick={onClick}
        ref={ref}
      >
        <h3>{value ? value : "Select date range"}</h3>
      </div>
    </div>
  ));

  //fetch waybill
  const getWaybills = useCallback(
    async (newaggId, recId, formatStaDate, formatEdDate, genderState) => {
      const newEdDate = formatEndDate || formatEdDate;
      const newStaDate = formatStartDate || formatStaDate;
      const newrecId = recycId?.value || recId?.value;
      const newAgg = aggId?.value || newaggId?.value;
      const genderData = aggGender?.value || genderState?.value;

      const res = await getAllWaybills(
        page,
        limit,
        newAgg,
        newrecId,
        newStaDate,
        newEdDate,
        program,
        genderData,
      );
      setTotalPages(res.data?.totalPages);
      setTotalElements(res?.data?.totalElements);
      setTotalQty(res?.data?.transactionSummary.totalQuantity);
      setWaybills(res.data?.content);
    },
    [page, program],
  );
  useEffect(() => {
    getWaybills();
  }, [page, program, getWaybills]);

  //get lists
  useEffect(() => {
    const getAggregatorsList = async () => {
      const res = await gatAllAggregatorLists(program);
      const list = JSON.parse(res)?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });

      setAggregatorList([...list]);
    };

    const getRecyclerList = async () => {
      const res = await gatAllRecyclerLists(program);
      const list = res?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setRecyclerList([...list]);
    };
    getAggregatorsList();
    getRecyclerList();
  }, [program]);

  useEffect(() => {
    const getSetting = async () => {
      try {
        const res = await getEnabledSettingUsers("CAN_DELETE_RECORD");
        setCanDelete(
          userHasEnabledSetting(res, "CAN_DELETE_RECORD", accountId),
        );
      } catch (error) {
        setCanDelete(false);
      }
    };
    getSetting();
  }, [accountId]);

  useEffect(() => {
    const getSetting = async () => {
      const res = await gatOneSetting({ type: "DEACTIVATE_TRANSACTION" });
      setCanShowNewCollection(parseSettingBoolean(res?.data?.value));
    };
    getSetting();
  }, []);

  useEffect(() => {
    const getSetting = async () => {
      try {
        const res = await getEnabledSettingUsers("ACTIVATE_EDIT_TRANSACTION");
        setCanActivateEditTransaction(
          userHasEnabledSetting(res, "ACTIVATE_EDIT_TRANSACTION", accountId),
        );
      } catch (error) {
        setCanActivateEditTransaction(false);
      }
    };
    getSetting();
  }, [accountId]);

  const handleDelete = (id) => {
    deleteOneWaybill(id);
    setTimeout(() => {
      getWaybills();
    }, 1000);
    toast.success("Deleted succesfully");
  };

  const reset = () => {
    setAggId(null);
    setRecycId(null);
    getWaybills();
  };

  const nextPage = () => {
    setPage((prev) => (prev >= totalPages ? 1 : prev + 1));
    getWaybills(aggId, recycId, formatStartDate, formatEndDate);
  };
  const prevPage = () => {
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
    getWaybills(aggId, recycId, formatStartDate, formatEndDate);
  };

  const attachmentArray = waybillDetail?.attachment?.split("/");
  const isAttachmentUrl = waybillDetail?.attachment?.startsWith("https");
  const isAggregator = user.userType === "AGGREGATOR";
  const canShowEdit = user?.userType !== "PARTNER";

  const dataHeaders =
    user.userType !== "AGGREGATOR"
      ? headers
      : headers.filter(
        (data) => data !== "Aggregators" && data !== "Gender",
      );
  const tableHeaders = canShowEdit ? [...dataHeaders, ""] : dataHeaders;

  const plasticTypeOptions = typeOfPlastic.map((data) => ({
    label: data.name,
    value: data.id,
  }));
  const plasticSourceOptions = sourceOfPlastic.map((data) => ({
    label: data.name,
    value: data.id,
  }));

  const handleEdit = (data) => {
    setWaybillDetail(data);
    if (canActivateEditTransaction) {
      setEditDetail(true);
    }
    if (!canActivateEditTransaction) {
      setShowEditFalseModal(true);
    }
  };

  const getRowActions = (data, index) => {
    const actions = {
      open: (
        <MdOutlineRemoveRedEye
          key={`view-${index}`}
          onClick={() => {
            setViewDetail(true);
            setWaybillDetail(data);
          }}
        />
      ),
    };

    if (canShowEdit) {
      actions.edit = (
        <FiEdit
          key={`edit-${index}`}
          onClick={() => handleEdit(data)}
        />
      );
    }

    actions.delete = user?.userType !== "PARTNER" && (
      <MdDelete
        key={`delete-${index}`}
        width={30}
        onClick={() => {
          if (canDelete) {
            setWaybillId(data.id);
            setShowDeleteModal(true);
          }
          setShowDeleteFalseModal(true);
        }}
      />
    );

    return actions;
  };

  return (
    <div className="p-4">
      <div className="mb-10">
        <TopCard
          title={"Offtake"}
          subtitle={"List of waybill on the platform."}
          buttonTitle={"New Offtake"}
          Icon={GoPlus}
          setShowModal={() => setShowModal(true)}
          exportType="waybill"
          userType={user?.userType}
          downloadData={() =>
            waybillDownload({
              recyclerId: recycId?.value,
              aggregatorId: aggId?.value,
              startDate,
              endDate,
              program,
            })
          }
        />
      </div>
      <div className="flex gap-[20px] mb-10">
        <DataCard
          css={"bg-[#FFFAEB] w-[100%]"}
          image={Character}
          title={"Total Offtake"}
          subtitle={toMoney(totalQty) || 0}
        />
      </div>

      <div className="mb-10 flex flex-col justify-between md:flex-row lg:flex-row gap-2">
        <div className="flex flex-wrap md:gap-2 gap-2">
          <SearchableDropdown
            options={aggregatorList || []}
            dropDownStyle={{ display: isAggregator ? "none" : "block" }}
            placeholder="Filter by aggregator"
            selectedOption={aggId}
            defaultValue={null}
            handleChange={(e) => {
              setAggId(e);
            }}
          />
          <SearchableDropdown
            options={[
              {
                label: "Male",
                value: "Male",
              },
              {
                label: "Female",
                value: "Female",
              },
            ]}
            selectedOption={aggGender}
            defaultValue={null}
            dropDownStyle={{ display: isAggregator ? "none" : "block" }}
            placeholder="Filter by Gender"
            className={"w-[180px]"}
            handleChange={(e) => {
              setAggGender(e);
            }}
          />
          <SearchableDropdown
            options={recyclerList || []}
            placeholder="Filter by Offtaker"
            selectedOption={recycId}
            defaultValue={null}
            handleChange={(e) => {
              setRecycId(e);
            }}
          />
        </div>
        <div className="flex lg:flex-row lg:flex-nowrap gap-2">
          {/* date range*/}
          <DatePicker
            selected={startDate}
            onChange={onChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            customInput={<ExampleCustomInput />}
            showYearDropdown
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            isClearable
          />

          {/* <InputSearch
            placeholder={"search"}
            inputValue={query}
            setInputValue={setQuery}
            css="w-[150px]"
          /> */}

          <button
            className="flex justify-center items-center h-[44px] w-[80px] lg:w-[101px] border border-gray-300 gap-2 rounded-md"
            onClick={() =>
              getWaybills(
                aggId,
                recycId,
                formatStartDate,
                formatEndDate,
                aggGender,
              )
            }
          >
            Apply
          </button>
          <button
            className="flex justify-center items-center h-[44px] w-[60px] border border-gray-300 gap-2 rounded-md"
            onClick={() => reset()}
          >
            refresh
          </button>
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center">
          <p className="text-center">Loading...</p>
        </div>
      ) : waybill?.length === 0 ? (
        <div className="flex justify-center">
          <p className="text-center">No data.</p>
        </div>
      ) : (
        <CustomTable
          headers={tableHeaders}
          rows={
            user.userType !== "AGGREGATOR"
              ? waybill?.map((data, index) => {
                return {
                  recycler: data.recycler ? data.recycler : "N/A",
                  aggregator: data.aggregator ? data.aggregator : "N/A",
                  gender: data?.aggregatorGender
                    ? data?.aggregatorGender
                    : "N/A",
                  amount: data.amount
                    ? "NGN " + toMoneyDecimal(data.amount)
                    : 0,
                  quantity: data.quantity ? toMoneyDecimal(data.quantity) : 0,
                  transactionDate: data?.transactionDate,
                  date: data.createdAt ? data.createdAt : 0,
                  ...getRowActions(data, index),
                };
              })
              : waybill?.map((data, index) => {
                return {
                  recycler: data.recycler ? data.recycler : "N/A",
                  amount: data.amount ? toMoney(data.amount) : 0,
                  quantity: data.quantity ? toMoneyDecimal(data.quantity) : 0,
                  gender: data?.aggregatorGender
                    ? data?.aggregatorGender
                    : "N/A",
                  transactionDate: data?.transactionDate,
                  date: data.createdAt ? data.createdAt : 0,
                  ...getRowActions(data, index),
                };
              })
          }
        />
      )}
      <PaginationPane
        currentPage={page > 1 ? page : 1}
        totalPages={totalPages || 1}
        nextPage={() => nextPage()}
        prevPage={() => prevPage()}
      />
      {showModal && !canShowNewCollection && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowModal(false)}
        >
          <WaybillModal
            closeModal={() => setShowModal(false)}
            aggregatorList={aggregatorList}
            recyclerList={recyclerList}
            getWaybills={getWaybills}
            isAggregator={isAggregator}
            selectOptDefault={
              isAggregator
                ? { label: user.name, value: user?.aggregatorId }
                : {
                  label: waybillDetail.aggregator,
                  value: waybillDetail.aggregatorId,
                }
            }
            sourceOfPlastic={plasticSourceOptions}
            typeOfPlastic={plasticTypeOptions}
          />
        </Modal>
      )}

      {showModal && canShowNewCollection && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowModal(false)}
            msg={"Feature disabled, please contact admin"}
          />
        </Modal>
      )}
      {editDetail && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setEditDetail(false)}
        >
          <WaybillModal
            closeModal={() => setEditDetail(false)}
            requestType={"edit"}
            userData={waybillDetail}
            aggregatorList={aggregatorList}
            recyclerList={recyclerList}
            getWaybills={getWaybills}
            isAggregator={isAggregator}
            selectOptDefault={
              isAggregator
                ? { label: user.name, value: user?.aggregatorId }
                : {
                  label: waybillDetail.aggregator,
                  value: waybillDetail.aggregatorId,
                }
            }
            sourceOfPlastic={plasticSourceOptions}
            typeOfPlastic={plasticTypeOptions}
          />
        </Modal>
      )}
      {viewDetail && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setViewDetail(false)}
        >
          <ViewDetail
            detail={{
              aggregator: waybillDetail.aggregator
                ? waybillDetail.aggregator
                : "N/A",
              recycler: waybillDetail.recycler ? waybillDetail.recycler : "N/A",
              "quantity(Kg)": waybillDetail.quantity
                ? toMoney(waybillDetail.quantity || 0)
                : 0,
              "amount(NGN)": waybillDetail.amount
                ? toMoney(waybillDetail.amount || 0)
                : 0,
              "Source Of Plastic": waybillDetail.sourceOfPlastic
                ? waybillDetail.sourceOfPlastic
                : "N/A",
              "Type Of Plastic": waybillDetail.typeOfPlastic
                ? waybillDetail.typeOfPlastic
                : "N/A",
              attachment: (
                <>
                  {attachmentArray
                    ? attachmentArray[attachmentArray?.length - 1]
                    : ""}{" "}
                  {isAttachmentUrl ? (
                    <a
                      className="bg-[#079455] text-white w-[128px]  p-2 rounded-3xl flex gap-1 items-center justify-center"
                      href={waybillDetail.attachment}
                    >
                      <GoDownload /> Download
                    </a>
                  ) : (
                    <a
                      className="bg-[#079455] text-white w-[128px]  p-2 rounded-3xl flex gap-1 items-center justify-center"
                      style={{ cursor: "default", pointerEvents: "none" }}
                      href={waybillDetail.attachment}
                    >
                      <GoDownload /> Download
                    </a>
                  )}
                </>
              ),
            }}
            closeModal={() => setViewDetail(false)}
            title={"Offtake Details"}
            subtitle={"Offtake details below"}
            dateCreated={"14 January 2024"}
            editbutton={canShowEdit}
            onEdit={() => {
              setViewDetail(false);
              handleEdit(waybillDetail);
            }}
            createdAt={waybillDetail.createdAt}
          />
        </Modal>
      )}
      {showDeleteModal && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowDeleteModal(false)}
        >
          <DeleteModal
            closeModal={() => setShowDeleteModal(false)}
            handleDelete={() => handleDelete(waybillId)}
          />
        </Modal>
      )}

      {showDeleteFalseModal && !canDelete && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowDeleteFalseModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowDeleteFalseModal(false)}
            msg={"Cannot delete record. Please contact admin."}
          />
        </Modal>
      )}
      {showEditFalseModal && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowEditFalseModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowEditFalseModal(false)}
            msg={"Cannot Edit record. Please contact admin."}
          />
        </Modal>
      )}
    </div>
  );
};

export default Offtake;

